<template>
  <PopupContent :bodyClass="['word-list']">
    <template #header>
      <div class="word-view-header">
        <div class="word-view-title">
          <span class="title-icon">📚</span>
          <span>{{ $t('wordViewPopup.title', { count: viewModel.words.length }) }}</span>
        </div>
      </div>
    </template>

    <div
        v-for="(word, index) in viewModel.words"
        :key="index"
        class="word-item"
    >
      <div class="word-original"
           :class="getTextClass(viewModel.learnedLanguage)"
      >
        <span class="word-original-main">{{ word.original }}</span>
        <span
            v-if="word.transliteration && word.transliteration!==word.original && word.transliteration!==word.translation"
            class="word-transliteration"
            :class="getTextClass(viewModel.nativeLanguage)">
          ({{ word.transliteration }})
        </span>
      </div>
      <div class="word-arrow">→</div>
      <div class="word-translation"
           :class="getTextClass(viewModel.nativeLanguage)"

      >{{ word.translation }}
      </div>
    </div>
  </PopupContent>
</template>

<script setup lang="ts">
import PopupContent from '../components/PopupContent.vue';
import type { WordViewPopupViewModel } from '../popup-view-models/word-view-popup.view-model'
import { getTextClass } from '../styles/get-text-classes';

interface Props {
  readonly viewModel: WordViewPopupViewModel
}

defineProps<Props>()
</script>

<style scoped lang="less">
@import "../styles/global.less";
@import "../styles/text-styles.less";

.word-view-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 0;
}

.word-view-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: var(--font-size-header);
  color: #333;
}

.title-icon {
  font-size: var(--font-size-header);
}

.word-list {
  padding-right: 8px;
}

.word-item {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  gap: 16px;
  padding: 16px;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    background: #f8f9fa;
    transform: translateX(4px);
  }

  &:not(:last-child) {
    border-bottom: 1px solid #e9ecef;
  }
}

.word-original {
  min-width: 0;
  font-size: var(--font-size-regular);
  color: #333;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  overflow-wrap: anywhere;
}

.word-original-main {
  display: block;
}

.word-transliteration {
  display: block;
  font-size: var(--font-size-regular);
  line-height: 1.25;
  opacity: 0.9;
  white-space: normal;
  overflow-wrap: anywhere;
}

.word-arrow {
  font-size: var(--font-size-subheader);
  color: #667eea;
  line-height: 1;
}

.word-translation {
  min-width: 0;
  font-size: var(--font-size-regular);
  color: #667eea;
  overflow-wrap: anywhere;

}

/* Mobile Responsive */
@media (max-width: 768px) {
  .word-view-title {
    font-size: var(--font-size-subheader);

    span:not(.title-icon) {
      font-size: var(--font-size-regular);
    }
  }

  .title-icon {
    font-size: var(--font-size-header);
  }

  .word-item {
    gap: 10px;
    padding: 14px;
  }

  .word-arrow {
    font-size: var(--font-size-regular);
  }

  .word-original,
  .word-translation {
    font-size: var(--font-size-button);
  }
}

@media (max-width: 480px) {
  .word-view-popup {
    padding: 16px;
  }

  .word-view-title {
    font-size: var(--font-size-regular);
    gap: 8px;

    span:not(.title-icon) {
      font-size: var(--font-size-button);
    }
  }

  .title-icon {
    font-size: var(--font-size-subheader);
  }

  .word-item {
    padding: 12px;
  }

  .word-original,
  .word-translation {
    font-size: var(--font-size-regular);
  }
}
</style>

